var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-brand',{attrs:{"href":_vm.cityWebsite,"target":"__blank"}},[_c('img',{staticClass:"align-top",attrs:{"id":"city_logo","src":_vm.logoLink,"alt":"Logo"}}),_c('div',{staticClass:"align-top",attrs:{"id":"city_name"}},[_vm._v(_vm._s(_vm.cityName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }